import api from '../../../../api';

export const HighlightSelector = {
  HIGHLIGHT: api.internals.ns.selector('highlight')
};
